<template lang="pug">
  .home

    include mixins.pug

    Navbar
    .section.list(v-if='!showDetail')
      .subtitle Cobrador
      .level.panel
        form(@submit.prevent='searchAction').level-left
          .level-item
            input.input(placeholder='Nombre' v-model='search.nombre')
          .level-item
            button.button.is-primary(:class="{'is-loading': searching}") Buscar
      progress.progress.is-small.is-primary(v-if='searching' max='100') 50

      table.table.is-bordered.is-striped.is-fullwidth.is-hoverable
        thead
          tr
            th Cobrador
            th Nombre
            th Telefono
            th Ciudad
            th Comision
            th Ci
            th Codigo
            th Morosos
            th Cel Corp
            th Supervisor
            th Recaudado
            th Acciones
        tbody(v-for='row in cobradorList')
          tr
            td {{ row.cobrador }}
            td {{ row.nombre }}
            td {{ row.telefono }}
            td {{ row.ciudad }}
            td {{ row.comision }}
            td {{ row.ci }}
            td {{ row.codigo }}
            td {{ row.morosos ? 'Si' : 'No' }}
            td {{ row.cel_corp }}
            td {{ row.supervisor }}
            td {{ row.recaudado ? 'Si' : 'No' }}
            td.has-text-centered
              button.button.is-primary(@click.prevent='verDatos(row)') Datos

    .section.detail(v-else @keyup.esc='showDetail = false')
      h1.title Detalles de cobrador
        form.form
          .columns
            +textField('Cobrador', 'cobradorInstance.cobrador', 'cobradorInput')
            +textField('Nombre', 'cobradorInstance.nombre')
          .columns
            +textField('Dirección', 'cobradorInstance.direccion')
            +textField('Telefono', 'cobradorInstance.telefono')
          .columns
            +textField('Ciudad', 'cobradorInstance.ciudad')
            +textField('Comision', 'cobradorInstance.comision')
          .columns
            +textField('Obs', 'cobradorInstance.obs')
            +textField('Ci', 'cobradorInstance.ci')
          .columns
            +textField('Fecha Nacimiento', 'cobradorInstance.fec_nac')
            +textField('Fecha Ingreso', 'cobradorInstance.fec_ingr')
          .columns
            +textField('Sueldo', 'cobradorInstance.sueldo')
            +textField('Clientes', 'cobradorInstance.clientes')
          .columns
            +textField('Ingres Mes', 'cobradorInstance.ingres_mes')
            +textField('Codigo', 'cobradorInstance.codigo')
          .columns
            +checkboxField('Morosos', 'cobradorInstance.morosos')
            +textField('Cel Corp', 'cobradorInstance.cel_corp')
          .columns
            +textField('Supervisor', 'cobradorInstance.supervisor')
            +checkboxField('Recaudado', 'cobradorInstance.recaudado')
          .columns
            +textField('Dcto Ips', 'cobradorInstance.dcto_ips')
            +textField('Dcto Corp', 'cobradorInstance.dcto_corp')
          .columns
            +textField('Ingr A Ips', 'cobradorInstance.ingr_a_ips')
          button.button.is-info(@click.prevent='showDetail = false') Volver

</template>

<script>

import Navbar from '@/components/Navbar.vue'
import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/firestore';

async function busqueda(search) {
  var query = firebase.firestore().collection('cobrador').limit(100)

  // firebase no soporte rage search (<=, >=, etc.) con más de un campo.
  if(search.nombre) 
    query = query.where('nombre', '>=', search.nombre)
  let cobradorList = []

  return query.get().then(snapshot => {
    snapshot.forEach(doc => cobradorList.push(doc.data()))
    return cobradorList
  })
}

export default {
  data () {
    return {
      cobradorList: [],
      cobradorInstance: {}, 
      search: {
        nombre: null,
      },
      searching: false,
      showDetail: false
    }
  },
  filters: {
    dateFmt(date) {
      if (date)
        return date.split('T')[0]
      return date
    }
  },
  components: {
    Navbar
  },
  created: function() {
    this.searching = true
    firebase.auth().onAuthStateChanged(user => {
      busqueda(this.search).then(list => {
        this.cobradorList = list
        this.searching = false
      })
    })
  },
  methods: {
    searchAction: function () {
      this.searching = true
      busqueda(this.search).then(list => {
        this.cobradorList = list
        this.searching = false
      })
    },
    verDatos: function (instance) {
      this.cobradorInstance = instance
      this.showDetail = true
      this.$nextTick(() => this.$refs.cobradorInput.focus())
    }
  }
}
</script>
